import { gql } from '@apollo/client'

export const GET_ACTIVE_MARKET_ENTRIES = gql`
  query GetActiveMarketEntries($fantasyLeagueId: ID!) {
    activeMarketEntries(fantasyLeagueId: $fantasyLeagueId) {
      id
      price
      status
      listedAt
      expiresAt
      bidCount
      player {
        id
        createdAt
        nick
        name
        lastName
        role
        marketValue
        image
        totalScore
        lastWeekScore
        lastWeekNumber
        team {
          id
          competition {
            id
            code
            displayName
            rank
          }
          createdAt
          nameShow
          shortName
          shield
        }
      }
      seller {
        id
        teamName
        user {
          id
          fullName
        }
      }
    }
  }
`
